module.exports = __webpack_public_path__ + "img/wdybg.7eb8444f.png";